import { Component, OnInit, Input, ViewChild, ViewChildren, TemplateRef, OnDestroy } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { InstitutionImageLibrary } from '../Models/InstitutionImageLibrary';
import { PHBHPFeaturePackageConfigurationService } from '../ph-bhp-feature-package-configuration.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AppConfig } from 'src/app/app.config';
import { Subscription } from 'rxjs';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-configure-image-institution',
  templateUrl: './ph-bhp-configure-image-institution.component.html',
  styleUrls: ['./ph-bhp-configure-image-institution.component.css']
})
export class PhBhpConfigureImageInstitutionComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  @ViewChild("ngForm") ngForm
  collapseExample = false;
  public imagePath;
  public message: string;
  imageURL: any;
  deleteImage;
  searchText;
  imageId: any = null;
  URL: string;
  serverUrl;
  index;
  isPreview = true
  imageLibDescriptionMaxlength = 500;
  imagenamelength = 40;
  userData;
  institutions: any;
  InstitutionsList: [any];
  institutionID: number;
  itemChange: boolean = false;
  mygroup: UntypedFormGroup
  @ViewChild('template') template: TemplateRef<any>;
  @ViewChild('sopWrapper') sopWrapper;
  @ViewChild('newImage') newImage;
  @ViewChildren('cdkDragList') cdkDragList;
  @ViewChild('delmodal') delmodal: TemplateRef<any>;
  @ViewChild('arrw') arrw;
  @ViewChild('arrwShadow') arrwShadow;
  @ViewChild('tagInput') tagInput;
  selectedInstitution
  selected

  modalRef: BsModalRef;
  ImageData: Array<InstitutionImageLibrary>;
  addImageInstitutionForm: UntypedFormGroup;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  public items: any[] = [];
  formatTexts: any[] = [];

  constructor(private modalService: BsModalService,
    public translate: TranslateService, private service: PHBHPFeaturePackageConfigurationService,
    public layoutService: PHBHPLayoutPackageService,
    public router: Router,
    public appConfig: AppConfig
  ) {
    this.serverUrl = layoutService.serverUrl;
  }


  ngOnInit() {
    this.addImageInstitutionForm = new UntypedFormGroup({
      imageName: new UntypedFormControl("", Validators.compose([Validators.required])),
      description: new UntypedFormControl(
        "",
        Validators.compose([Validators.required])
      ),
      tags: new UntypedFormControl(""),
      imageURL: new UntypedFormControl("", Validators.compose([Validators.required])),

    });

    this.mygroup = new UntypedFormGroup({
      selectedIns: new UntypedFormControl(this.selected)
    });

    if (this.layoutService.institutionID) {
      //this.getImageList();
      this.userData = this.appConfig.userData;
      this.institutions = this.appConfig.institutions;
      this.OnInstitutionsChanges()
    }
    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((Id) => {
      this.userData = this.appConfig.userData;
      this.institutions = this.appConfig.institutions;
      this.OnInstitutionsChanges()
      this.getImageList();
    });

    var formatText = this.layoutService.translateText('CONFIGURE.JPG_OR_PNG_800X500');
    this.formatTexts = formatText.split('|');
    if (this.formatTexts.length == 1) {
      this.formatTexts = formatText.split('/');
    }

  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  OnInstitutionsChanges() {
    if (this.institutions && !this.itemChange) {
      this.itemChange = true;
      var roleId = this.appConfig.userData.roleName.roleId
      this.service.getInstitutionsbyId(this.institutions, roleId).subscribe((res: any) => {
        this.InstitutionsList = res;
        if (this.layoutService.institutionID) {
          this.institutionID = this.layoutService.institutionID;
        } else {
          if (res.length > 0) {
            this.institutionID = res[0].institution.institutionID;
          }
        }
        this.onInstitutionChange(this.institutionID);
      })
    }
  }

  openmodal(template: TemplateRef<any>) {
    this.mygroup.patchValue({
      selectedIns: this.selected
    })
    this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'w-420' })
    )
  }


  onInstitutionChange(value) {
    if (this.InstitutionsList) {
      //this.getWardList(value);
      this.layoutService.institutionID = value;
      this.getImageList();
      this.selected = this.InstitutionsList.find(x => x.institution.institutionID === value).institution.institutionID;
      this.selectedInstitution = this.InstitutionsList.find(x => x.institution.institutionID === value).institution.institutionName;
    }
  }

  showInstitutionDropDown() {
    if (this.InstitutionsList) {
      if (this.InstitutionsList.length < 2) {
        return false;
      } else {
        return true;
      }
    }
  }

  getInstitutionName() {
    if (this.InstitutionsList) {
      return this.InstitutionsList[0].institution.institutionName;
    }
  }

  getInstition() {
    this.service.GetInstitutionDetails(this.layoutService.institutionID).subscribe((res: any) => {
    });
  }

  openWrapper(index) {
    this.items = [];
    this.cdkDragList.forEach(cdkDrag => cdkDrag.nativeElement.classList.remove('active'));
    this.newImage.nativeElement.classList.remove('active');
    var phElement = this.cdkDragList._results[index].nativeElement;
    phElement.classList.add('active');

    var x = phElement.offsetTop + 115;
    var y = phElement.offsetLeft;
    this.sopWrapper.nativeElement.style.top = x + 'px';
    this.sopWrapper.nativeElement.style.left = '0px';
    this.arrw.nativeElement.style.left = y + 35 + 'px';
    this.arrwShadow.nativeElement.style.left = y + 33 + 'px';
    this.collapseExample = true;
    this.index = index;
    this.tagInput.nativeElement.value = "";
    this.editImage(this.ImageData[index])
  }
  openNewWrapper() {
    this.items = [];
    this.cdkDragList.forEach(cdkDrag => cdkDrag.nativeElement.classList.remove('active'));
    // this.newImage.nativeElement.classList.add('active');
    var x = this.newImage.nativeElement.offsetTop + 130;
    var y = this.newImage.nativeElement.offsetLeft;
    this.sopWrapper.nativeElement.style.top = x + 'px';
    this.sopWrapper.nativeElement.style.left = '0px';
    this.arrw.nativeElement.style.left = y + 35 + 'px';
    this.arrwShadow.nativeElement.style.left = y + 33 + 'px'
    this.collapseExample = true;
    this.saveImage();
  }
  toggleSingleSOP() {
    this.collapseExample = false;
  }
  saveImage() {
    this.imagePath = null;
    this.imageId = null;
    this.imageURL = null;
    this.index = null;
    this.ngForm.submitted = false;
    this.ngForm.reset();
    this.addImageInstitutionForm.reset();
  }

  preview(files) {
    if (files.length === 0) return;

    // var mimeType = files[0].type;
    // if (mimeType.match(/image\/*/) == null) {
    //   this.message = "Only images are supported.";
    //   return;
    // }
    this.isPreview = true;
    var reader = new FileReader();
    this.imagePath = files;
    if (this.imagePath[0].size > 1000000) {
      this.layoutService.showError(this.layoutService.translateText('CONFIGURE.IMAGE_SIZE_TOO_BIG'));
    } else {
      reader.readAsDataURL(files[0]);
      reader.onload = _event => {
        this.imageURL = reader.result;
        this.addImageInstitutionForm.patchValue({
          imageURL: this.imageURL
        })
      };
    }
  }

  upload(files) {

    if (this.addImageInstitutionForm.invalid) {
      return;
    }
    if ((this.imagePath[0].type.indexOf("png")) < 0 && (this.imagePath[0].type.indexOf("jpeg")) < 0) {
      this.layoutService.showError(this.layoutService.translateText('CONFIGURE.MESSAGE_INVALID_FILE.EXPECTED_JPG_OR_PNG'));
      return;
    }
    if (this.imagePath.length === 0) return;

    const value: InstitutionImageLibrary = this.addImageInstitutionForm.value;
    const formData = new FormData();
    var userId = this.userData.userId;
    var institutionID = this.layoutService.institutionID;

    formData.append("ImageURL", this.imagePath[0]);
    formData.append("imageName", value.imageName);
    formData.append("description", value.description);
    formData.append("tags", JSON.stringify(this.items));
    formData.append("createdBy", userId);
    formData.append("institutionID", institutionID.toString());
    //formData.append("", )


    this.layoutService.showLoader = true;
    this.service.uploadImage(formData).subscribe((res: Array<InstitutionImageLibrary>) => {
      this.layoutService.showLoader = false;
      // this.layoutService.showSuccess(this.layoutService.translateText('CONFIGURE.MESSAGE_SUCCESSFULLY.ADDED.IMAGE_TO_LIBRARY'));
      // this.router.navigateByUrl('/configure/wards', { skipLocationChange: true }).then(() =>
      //   this.router.navigate(["configure/image-institution"]));
      //res = this.ImageData;
      // this.imageURL = null;
      this.collapseExample = false;
      this.getImageList();

    });
  }

  getImageList() {

    this.service.getImagesByInstitutionId(this.layoutService.institutionID).subscribe((res: Array<InstitutionImageLibrary>) => {
      this.ImageData = res;
    });
  }
  openDeleteModal(deletemodal: TemplateRef<any>) {
    this.deleteImage = this.ImageData[this.index];
    this.modalRef = this.modalService.show(deletemodal, Object.assign({}, { class: 'w-420' })
    )
  }

  removeImage() {
    this.service
      .deleteImageById(this.deleteImage.imageLibraryID)
      .subscribe((res: Array<InstitutionImageLibrary>) => {
        var data: Array<InstitutionImageLibrary> = this.ImageData;
        this.ImageData = [];
        var index = data.findIndex(
          imageFile => imageFile.imageLibraryID === this.deleteImage.imageLibraryID
        );
        data.splice(index, 1);
        this.ImageData = data;
        this.collapseExample = false;
        // this.imageURL = null;
        this.index = null;
        // this.router.navigateByUrl('/configure/wards', { skipLocationChange: true }).then(() =>
        //   this.router.navigate(["configure/image-institution"]));
      });

  }
  editImage(image: InstitutionImageLibrary) {
    this.isPreview = false;

    this.imageId = image.imageLibraryID;
    this.addImageInstitutionForm.patchValue({
      imageName: image.imageName,
      description: image.description,
      tags: JSON.parse(image.tags),
      ImageURL: image.imageURL
    });
    this.imageURL = image.imageURL;
    if (this.addImageInstitutionForm.value.tags.length > 0) {
      for (let i = 0; i < this.addImageInstitutionForm.value.tags.length; i++) {
        this.items.push(this.addImageInstitutionForm.value.tags[i]);
      }
    }
  }

  updateImage(file) {
    const value: InstitutionImageLibrary = this.addImageInstitutionForm.value;
    const formData = new FormData();
    var userId = this.userData.userId;
    if (!file && !this.imagePath && this.imagePath.length <= 0) {
      formData.append("imageName", value.imageName);
      formData.append("description", value.description);
      formData.append("tags", JSON.stringify(this.items));
      formData.append("updatedBy", userId);
      formData.append("institutionID", this.layoutService.institutionID.toString());
    } else {
      if (!this.imagePath) {
        this.imagePath = file;
      }
      if ((this.imagePath[0].type.indexOf("png")) < 0 && (this.imagePath[0].type.indexOf("jpeg")) < 0) {
        this.layoutService.showError(this.layoutService.translateText('CONFIGURE.MESSAGE_INVALID_FILE.EXPECTED_JPG_OR_PNG'));
        return;
      }
      formData.append("ImageURL", this.imagePath[0]);
      formData.append("imageName", value.imageName);
      formData.append("description", value.description);
      formData.append("tags", JSON.stringify(this.items));
      formData.append("updatedBy", userId);
      formData.append("institutionID", this.layoutService.institutionID.toString());
    }

    this.layoutService.showLoader = true;
    this.service.updateImageById(this.imageId, formData)
      .subscribe((res: Array<InstitutionImageLibrary>) => {
        this.layoutService.showLoader = false;
        // this.layoutService.showSuccess(this.layoutService.translateText('CONFIGURE.MESSAGE_SUCCESSFULLY.UPDATED.IMAGE_TO_LIBRARY'));
        // this.router.navigateByUrl('/configure/wards', { skipLocationChange: true }).then(() =>
        //   this.router.navigate(["configure/image-institution"]));

        // res = this.ImageData;
        this.imagePath = null;
        this.imageId = null;
        this.imageURL = null;
        this.collapseExample = false;
        this.addImageInstitutionForm.reset();
        this.getImageList();
      });
  }

  onInputTagKeyup(target: any): void {
    if (target.value == '' || target.value.length == 0) return;
    this.items.push({ value: target.value });
    target.value = '';
  }

  remove(tag: any): void {
    const index = this.items.indexOf(tag);
    if (index >= 0) {
      this.items.splice(index, 1);
    }
  }

  canWriteOnInput(event: any, maxLength) {
    if (event.target.value.length >= maxLength) {
      event.target.value = event.target.value.substring(0, maxLength);
    }
  }
}
